import {h, Fragment} from "preact"
export default function CheckboxFilters({ facet, toggleProductFilter }) {

    return (
        <ul class="ns-filters-list ns-checkbox-list">
            {facet.data?.map(value => (
                <li
                    class="ns-filter-item"
                    data-nosto-element="facet-setting"
                >
                    <label class="ns-filter-label">
                        <input 
                            type="checkbox"
                            class="ns-filter-input"
                            checked={value.selected} 
                            onChange={(e) => {
                                e.preventDefault()
                                toggleProductFilter(facet.field, value.value, !value.selected)
                            }}
                        />
                        <span class="ns-filter-text">
                            {value.value} ({value.count})
                        </span>
                    </label>
                </li>
            ))}
        </ul>
    )
}